// ServiceSpecificationに基づいてMerchandisingのFeatureFlagsを作成します。
import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定のマーチャンダイジングに関するFeatureFlagsを作成します。
// pick_pack.ts / delivery_method.ts と同様のパターンで、partner_config.ts の
// createServiceSpecificationBackedFeatureFlags にスプレッドして組み込まれます。
export function createPartnerConfigFeatureFlagsMerchandisingPart(spec: ServiceSpecification) {
  return {
    get showBundleMixmatch(): boolean {
      // ServiceSpecのfieldが未定義（古いSpecやフィールド追加前のパートナー）のときは
      // fallback値が使われるようにfalseを返す。trueチェックはundefinedを安全に扱うため。
      return spec.merchandising?.enableBundleMixmatch === true
    },
    get enableMultipleMasterDataUpload(): boolean {
      // masterDataはmerchangingとは別ドメインのフィールドだが、
      // 管理画面上のフィーチャーフラグとしてmerchandisingパートにまとめて管理している。
      return spec.masterData?.enableMultipleMasterDataUpload === true
    },
    get enableEditAlcoholSalesManagementInfo(): boolean {
      return spec.merchandising?.alcohol?.enableEditAlcoholSalesManagementInfo === true
    },
  }
}
